import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import BottomNav from '../BottomNav';
import theme from '../theme';

function ReportProblem({ session, profile }) {
  const navigate = useNavigate();
  const [type, setType] = useState('');
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async () => {
    if (!type) { alert('Seleziona una categoria!'); return; }
    if (!description.trim()) { alert('Scrivi una descrizione!'); return; }
    setSubmitting(true);

    const { error } = await supabase.from('reports').insert({
      user_id: session.user.id,
      user_name: profile?.full_name || null,
      user_email: session.user.email,
      type,
      description: description.trim(),
    });

    setSubmitting(false);
    if (error) { alert('Errore: ' + error.message); return; }
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div style={{ maxWidth: theme.layout.maxWidth, margin: '0 auto', fontFamily: theme.font.family, padding: 40, textAlign: 'center' }}>
        <div style={{ fontSize: 60, marginBottom: theme.spacing.lg }}>✅</div>
        <h2 style={{ color: theme.colors.primary }}>Grazie per la segnalazione!</h2>
        <p style={{ color: theme.colors.textSecondary }}>L'abbiamo ricevuta e la esamineremo al più presto.</p>
        <button onClick={() => navigate('/profilo')} style={{
          background: theme.colors.primary, color: theme.colors.white, border: 'none',
          borderRadius: theme.radius.lg, padding: '14px 32px', fontSize: theme.font.size.xl, cursor: 'pointer', marginTop: theme.spacing.lg
        }}>Torna al profilo</button>
        <BottomNav />
      </div>
    );
  }

  return (
    <div style={{ maxWidth: theme.layout.maxWidth, margin: '0 auto', fontFamily: theme.font.family }}>
      <div style={{ background: theme.colors.primary, padding: '16px 20px', display: 'flex', alignItems: 'center', gap: theme.spacing.md }}>
        <button onClick={() => navigate('/profilo')} style={{ background: 'none', border: 'none', color: theme.colors.white, fontSize: 22, cursor: 'pointer', padding: 0 }}>←</button>
        <h2 style={{ margin: 0, color: theme.colors.white, fontSize: theme.font.size.xxl }}>🚩 Segnala un problema</h2>
      </div>

      <div style={{ padding: theme.spacing.xl, paddingBottom: 80 }}>

        <div style={{ marginBottom: theme.spacing.xl }}>
          <label style={{ fontSize: theme.font.size.base, color: theme.colors.textSecondary, display: 'block', marginBottom: theme.spacing.sm }}>Di cosa si tratta?</label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.sm }}>
            <button onClick={() => setType('problema')} style={{
              display: 'flex', alignItems: 'center', gap: theme.spacing.md,
              padding: theme.spacing.lg, borderRadius: theme.radius.lg, cursor: 'pointer', textAlign: 'left',
              border: type === 'problema' ? `2px solid ${theme.colors.primary}` : `1px solid ${theme.colors.border}`,
              background: type === 'problema' ? theme.colors.primaryLight : theme.colors.white,
            }}>
              <span style={{ fontSize: 28 }}>⚠️</span>
              <div>
                <div style={{ fontWeight: 700, fontSize: theme.font.size.md, color: theme.colors.textPrimary }}>Ho avuto un problema</div>
                <div style={{ fontSize: theme.font.size.sm, color: theme.colors.textMuted }}>Un bug, un utente scorretto, o qualcosa che non ha funzionato</div>
              </div>
            </button>
            <button onClick={() => setType('suggerimento')} style={{
              display: 'flex', alignItems: 'center', gap: theme.spacing.md,
              padding: theme.spacing.lg, borderRadius: theme.radius.lg, cursor: 'pointer', textAlign: 'left',
              border: type === 'suggerimento' ? `2px solid ${theme.colors.primary}` : `1px solid ${theme.colors.border}`,
              background: type === 'suggerimento' ? theme.colors.primaryLight : theme.colors.white,
            }}>
              <span style={{ fontSize: 28 }}>💡</span>
              <div>
                <div style={{ fontWeight: 700, fontSize: theme.font.size.md, color: theme.colors.textPrimary }}>Consigliaci cosa migliorare</div>
                <div style={{ fontSize: theme.font.size.sm, color: theme.colors.textMuted }}>Un'idea, una funzione che vorresti, un feedback generale</div>
              </div>
            </button>
          </div>
        </div>

        {type && (
          <div style={{ marginBottom: theme.spacing.xl }}>
            <label style={{ fontSize: theme.font.size.base, color: theme.colors.textSecondary, display: 'block', marginBottom: theme.spacing.sm }}>
              {type === 'problema' ? 'Descrivi il problema' : 'Descrivi il tuo suggerimento'}
            </label>
            <textarea
              value={description}
              onChange={e => setDescription(e.target.value)}
              placeholder={type === 'problema'
                ? "Raccontaci cosa è successo, più dettagli ci dai e più velocemente potremo aiutarti..."
                : "Raccontaci la tua idea..."}
              rows={6}
              style={{ width: '100%', padding: '12px', borderRadius: theme.radius.sm, border: `1px solid ${theme.colors.borderInput}`, fontSize: theme.font.size.md, boxSizing: 'border-box', resize: 'none', fontFamily: theme.font.family }}
            />
          </div>
        )}

        <button onClick={handleSubmit} disabled={submitting || !type || !description.trim()} style={{
          width: '100%', background: (!type || !description.trim()) ? theme.colors.textMuted : theme.colors.primary,
          color: theme.colors.white, border: 'none', borderRadius: theme.radius.lg, padding: 14,
          fontSize: theme.font.size.xl, cursor: (!type || !description.trim()) ? 'not-allowed' : 'pointer'
        }}>{submitting ? 'Invio...' : 'Invia segnalazione'}</button>
      </div>

      <BottomNav />
    </div>
  );
}

export default ReportProblem;